
import React from 'react';
import { Phone, Mail, Clock } from 'lucide-react';

const OfficeLocations = () => {
  const locations = [
    {
      name: "Rocky Mount Office",
      address: {
        company: "Carolina Trophy Roofs",
        street: "104 S. Business Ct",
        city: "Rocky Mount, NC 27804"
      },
      phone: "(252) 302-2003",
      phoneHref: "tel:+12523022003",
      email: "Claims@CarolinaTrophyRoofs.com",
      mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3245.9329780985036!2d-77.79269492346773!3d35.93820797231302!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89aedfea741b6fd5%3A0xd2aa82677c77832!2s104%20S%20Business%20Ct%2C%20Rocky%20Mount%2C%20NC%2027804!5e0!3m2!1sen!2sus!4v1716226429778!5m2!1sen!2sus",
      mapTitle: "Carolina Trophy Roofs Rocky Mount Location"
    },
    {
      name: "Greenville Office",
      address: {
        company: "Carolina Trophy Roofs",
        street: "1414 Forbes St",
        city: "Greenville, NC 27858"
      },
      phone: "(252) 371-2266",
      phoneHref: "tel:+12523712266",
      email: "Claims@CarolinaTrophyRoofs.com",
      mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3243.746761175222!2d-77.37311942392504!3d35.61266363881989!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89aec96ef8a6c6e5%3A0x6cf83c2e76ef0eae!2s1414%20Forbes%20St%2C%20Greenville%2C%20NC%2027858!5e0!3m2!1sen!2sus!4v1716308965429!5m2!1sen!2sus",
      mapTitle: "Carolina Trophy Roofs Greenville Location"
    },
    {
      name: "Tarboro Service Area",
      address: {
        company: "Carolina Trophy Roofs",
        street: "Tarboro, NC 27886",
        city: "Serving all of Edgecombe County"
      },
      phone: "(252) 302-2003",
      phoneHref: "tel:+12523022003",
      email: "Claims@CarolinaTrophyRoofs.com",
      mapSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d51897.04578053129!2d-77.56970597536732!3d35.90294083217773!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89ae9c59ed6af2df%3A0x71c0cf2b303ba357!2sTarboro%2C%20NC%2027886!5e0!3m2!1sen!2sus!4v1716309045839!5m2!1sen!2sus",
      mapTitle: "Carolina Trophy Roofs Tarboro Service Area"
    }
  ];

  return (
    <div className="space-y-12">
      {locations.map((location, index) => (
        <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="p-6">
            <h2 className="text-2xl font-bold mb-4">{location.name}</h2>
            <div className="flex flex-col md:flex-row gap-8">
              <div className="flex-1">
                <address className="not-italic mb-4 text-lg">
                  <p className="font-medium">{location.address.company}</p>
                  <p>{location.address.street}</p>
                  <p>{location.address.city}</p>
                </address>
                <div className="space-y-2">
                  <p className="flex items-center">
                    <Phone className="h-5 w-5 text-primary mr-2" />
                    <span className="font-medium">Phone:</span>{' '}
                    <a href={location.phoneHref} className="text-blue-600 hover:underline ml-1">
                      {location.phone}
                    </a>
                  </p>
                  <p className="flex items-center">
                    <Mail className="h-5 w-5 text-primary mr-2" />
                    <span className="font-medium">Email:</span>{' '}
                    <a
                      href={`mailto:${location.email}`}
                      className="text-blue-600 hover:underline ml-1"
                    >
                      {location.email}
                    </a>
                  </p>
                  <p className="flex items-center">
                    <Clock className="h-5 w-5 text-primary mr-2" />
                    <span className="font-medium">Hours:</span>{' '}
                    <span className="ml-1">Monday-Friday: 8am-5pm</span>
                  </p>
                </div>
              </div>
              <div className="flex-1">
                <div className="aspect-w-4 aspect-h-3 w-full h-[300px] rounded-md overflow-hidden">
                  <iframe 
                    src={location.mapSrc} 
                    width="100%" 
                    height="100%" 
                    style={{ border: 0 }} 
                    allowFullScreen 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    title={location.mapTitle}
                    className="rounded-md"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OfficeLocations;
